import { schema } from "normalizr";

export const calendarRateSchema = new schema.Entity("rates", undefined, {
  idAttribute: "date",
});
export const calendarRatesSchema = [calendarRateSchema];
